// For get pyament terms
export const GET_ADMIN_PAYMENT_TERMS = "GET_ADMIN_PAYMENT_TERMS"
export const GET_ADMIN_PAYMENT_TERMS_SUCCESS = "GET_ADMIN_PAYMENT_TERMS_SUCCESS"
export const GET_ADMIN_PAYMENT_TERMS_ERROR = "GET_ADMIN_PAYMENT_TERMS_ERROR"

export const UPDATE_ADMIN_PAYMENT_TERM = "UPDATE_ADMIN_PAYMENT_TERM"
export const UPDATE_ADMIN_PAYMENT_TERM_SUCCESS = "UPDATE_ADMIN_PAYMENT_TERM_SUCCESS"
export const UPDATE_ADMIN_PAYMENT_TERM_ERROR = "UPDATE_ADMIN_PAYMENT_TERM_ERROR"

export const POST_ADMIN_PAYMENT_TERM = "POST_ADMIN_PAYMENT_TERM"
export const POST_ADMIN_PAYMENT_TERM_SUCCESS = "POST_ADMIN_PAYMENT_TERM_SUCCESS"
export const POST_ADMIN_PAYMENT_TERM_ERROR = "POST_ADMIN_PAYMENT_TERM_ERROR"

